// regra comum dos campos de data/hora do Zinput (date, datetime, month, time):
// campo limpo e valor inválido viram null — nunca `Invalid Date`, que é truthy e passa despercebido por
// qualquer teste de "tem valor", chegando a viajar até o servidor (era o caso de apagar o horário do
// agendamento e digitar de novo: o campo guardava a data inválida e não se recuperava mais).
export function toValidDate(value: Date | string | null | undefined): Date | null {
    if (value === null || value === undefined || value === '') return null
    const date = value instanceof Date ? value : new Date(value)
    return isNaN(date.getTime()) ? null : date
}

// data local montada por partes — o "YYYY-MM-DD" puro seria lido como UTC pelo JS.
// o acerto do ano existe porque `new Date(year, …)` trata 0 a 99 como 1900+ano: o ano 1 virava 1901. isso
// não é borda de calendário, é o que acontece ao digitar — o input nativo entrega a data inteira já no
// primeiro dígito do ano ("0001-09-29"), e o 1901 voltando ao campo reescrevia o texto e zerava o
// acumulador de dígitos do navegador: digitar 1982 terminava em 1902, só o último dígito valia.
export function localDate(year: number, month: number, day = 1): Date {
    const date = new Date(year, month - 1, day)
    if (year >= 0 && year < 100) date.setFullYear(year)
    return date
}

// só escreve null quando há algo inválido pra limpar — evita reescrever (e invalidar o componente pai) à toa
export function isEmptyValue(value: Date | string | null | undefined): boolean {
    return value === null || value === undefined || value === ''
}
